import React from 'react';
import {
  WB_ICON,
  WB_ICON_CONTAINER,
  WB_MESSAGE,
  WB_SECTION,
  WB_SUBTITLE,
  WB_TITLE,
} from './warningBannerTestIds';

import styles from './WarningBanner.module.css';

const WarningBanner: React.FunctionComponent = (): JSX.Element => (
  <section data-testid={WB_SECTION} className={styles.wbContainer}>
    <div data-testid={WB_ICON_CONTAINER} className={styles.icon}>
      <i data-testid={WB_ICON} className={styles.faExclamationCircle} />
    </div>
    <div data-testid={WB_MESSAGE} className={styles.message}>
      <h4 data-testid={WB_TITLE} className={styles.title}>
        Payment Invalid
      </h4>
      <p data-testid={WB_SUBTITLE} className={styles.subtitle}>
        The payment method is invalid. Please update and try again.
      </p>
    </div>
  </section>
);

export default WarningBanner;
